// extracted by mini-css-extract-plugin
export var desktopSearch = "DesktopSearch-module--desktopSearch--e4e68";
export var searchButton = "DesktopSearch-module--searchButton--24861";
export var searchIcon = "DesktopSearch-module--searchIcon--6bfff";